/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillarySupplierValidationData
 */
export interface AncillarySupplierValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    ancillarySupplierCode?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    supplier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    ancillaryCategory?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    ancillary?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    carrier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    dateRange?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillarySupplierValidationData
     */
    duplicates?: ValidationMessage;
}

export function AncillarySupplierValidationDataFromJSON(json: any): AncillarySupplierValidationData {
    return AncillarySupplierValidationDataFromJSONTyped(json, false);
}

export function AncillarySupplierValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillarySupplierValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillarySupplierCode': !exists(json, 'ancillarySupplierCode') ? undefined : ValidationMessageFromJSON(json['ancillarySupplierCode']),
        'supplier': !exists(json, 'supplier') ? undefined : ValidationMessageFromJSON(json['supplier']),
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : ValidationMessageFromJSON(json['ancillaryCategory']),
        'ancillary': !exists(json, 'ancillary') ? undefined : ValidationMessageFromJSON(json['ancillary']),
        'carrier': !exists(json, 'carrier') ? undefined : ValidationMessageFromJSON(json['carrier']),
        'dateRange': !exists(json, 'dateRange') ? undefined : ValidationMessageFromJSON(json['dateRange']),
        'duplicates': !exists(json, 'duplicates') ? undefined : ValidationMessageFromJSON(json['duplicates']),
    };
}

export function AncillarySupplierValidationDataToJSON(value?: AncillarySupplierValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ancillarySupplierCode': ValidationMessageToJSON(value.ancillarySupplierCode),
        'supplier': ValidationMessageToJSON(value.supplier),
        'ancillaryCategory': ValidationMessageToJSON(value.ancillaryCategory),
        'ancillary': ValidationMessageToJSON(value.ancillary),
        'carrier': ValidationMessageToJSON(value.carrier),
        'dateRange': ValidationMessageToJSON(value.dateRange),
        'duplicates': ValidationMessageToJSON(value.duplicates),
    };
}


